import { Component, inject, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { category, categoryArr } from '@reflact/ipkv-types';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { Breadcrumb } from "primeng/breadcrumb";
import { ContextMenu } from "primeng/contextmenu";
import { TableModule } from "primeng/table";
import { Kategorie } from '../../services/kategorie';

@Component({
  imports: [Breadcrumb, TableModule, ContextMenu],
  templateUrl: './kategorien.html',
  styleUrl: './kategorien.scss',
  providers: [ConfirmationService]
})
export class Kategorien {
  @ViewChild('cm') cm!: ContextMenu;

  private router = inject(Router);
  private kategorieService = inject(Kategorie);
  protected home: MenuItem = { label: 'Kategorien' };
  protected categoryArr: category[] = [...categoryArr];

  protected onContextMenu(event: any, category: category) {
    this.kategorieService.selectedKategorie = category;
    this.cm.target = event.currentTarget;
    this.cm.model = this.getContextItems();
    this.cm.show(event);
  }

  private getContextItems(): MenuItem[] {
    return [
      {
        label: 'KI Korrektur Prompts bearbeiten',
        icon: 'pi pi-microchip-ai',
        command: () => { void this.router.navigate(["/", "system-prompts", this.kategorieService.selectedKategorie]); },
      },
      {
        label: 'Einleitung und Begrüßung',
        icon: 'pi pi-book',
        command: () => { void this.router.navigate(["/", "category-info", this.kategorieService.selectedKategorie]); },
      }
    ];
  }
}